/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal, displayErrorMessage } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './approvepopup_styles';

/* ========== ~~~~~~~~~~ CANCEL IMPORT POPUP~~~~~~~~~~ ========== */
const ApprovePopup = props => {
  const { handleApprove, handleCancel} = props
  const [isProcessing, setIsProcessing ] = useState(false)

  return (
    <SubPage name={`approvepopup`}  klass={props.classes.approvepopup} >
        <Copy name={`approvepopup`}>
            <BodyCopy>{`Are you sure you want to automatically approve commenting for this publisher?`}</BodyCopy>
        </Copy>
        <CTAs name={`ctas`} >
            <Button type={`action`} handleClick={handleCancel} variant={`normal`} name={`cancel`} text={`Cancel`} />
            <Button type={'action'} handleClick={() => { setIsProcessing(true); handleApprove(); }} variant={`action`} name={`approve`} text={`Approve`} processing={isProcessing} processingText={'Approving..'} />
        </CTAs>
    </SubPage>
  );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ApprovePopup);
